import { ISingleIdParams } from '../types/actionParams';
import { IDatasourceActions } from '../types/IDatasourceActions';
import { Request } from './Request';

export class GetDatasourceActionsRequest extends Request<ISingleIdParams, IDatasourceActions> {
  constructor(id: string) {
    super('getDatasourceActions', { id: id });
  }
}
